import Actions from "./ResourcesActionTypes";

export const getAllAvailableResources = (params = {}) => {
  return {
    type: Actions.FETCH_ALL_AVAILABLE_RESOURCES,
    payload: params,
  };
};
